import BasePlayer from 'services/sports/default/base-player';
import Action from 'actions';
import Const from 'constants';
import {getDefaultExposure} from 'helpers/player-helper';

export default class Player extends BasePlayer {
    resetSettings({incomingValues: {dispatch}}) {
        const {
            playersData: {players},
            userPointsType,
        } = Action.getState();

        const playersUserPoints = [];
        const playersExposure = [];

        players.getAllAsArr().map((player) => {
            playersUserPoints.push({
                playerId: player.playerId,
                name: player.name,
                userPoints: this.exec('applySympathyToPoints', {
                    player,
                    points: player[userPointsType.getUserPointsType()],
                }),
            });

            playersExposure.push({
                playerId: player.playerId,
                exposureMin: getDefaultExposure('min'),
                exposureMax: getDefaultExposure('max'),
            });
        });

        // dispatch(Action.do('resetFlexMaxExposurePositions'));
        // dispatch(Action.do('resetSuperFlexMaxExposurePositions'));
        dispatch(Action.do('resetExcludePlayersByRange'));
        dispatch(Action.set('PlayersExposure', playersExposure));
        dispatch(Action.set('UserPoints', playersUserPoints, Const.FLEX_MODE, false, {countPlayers: false}));

        return true;
    }
}
